export default __webpack_public_path__ + "file/Fiche-ES-Produit-Puroak-Copeaux.asset.6ffbd1e3.pdf";